export default {
  'Custom': '自定义',
  'Original': '原始',
}